<template>
  <div class="card">
    <div class="card-header">
      <div class="toolbar d-flex justify-content-between" @click="toggle()">
        <h4 class="card-title mb-0 align-self-center">
          <slot name="title"></slot>
        </h4>

        <button class="btn btn-sm btn-primary btn-circle align-self-center" v-if="enableToggle">
          <i
            class="fad"
            :class="{ 'fa-minus': expand, 'fa-plus': !expand }"
          ></i>
        </button>
      </div>
    </div>

    <div class="card-body" v-if="expand">
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    _expand: {
      Type: Boolean,
      default: true,
    },
    _enableToggle: {
      Type: Boolean,
      default: true,
    },
  },

  data(){
    return{
      expand: null,
      enableToggle: null
    }
  },

  created() {
    this.expand = this._expand;
    this.enableToggle = this._enableToggle;
    if (!this.enableToggle) this.expand = true;
  },

  methods: {
    toggle() {
      if (this.enableToggle) this.expand = !this.expand;
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  background-color: white;
  box-shadow: 2px 2px 25px 10px whitesmoke;
  border-radius: 0.25rem;

  .card-header,
  .card-body {
    padding: 1rem 2rem;
  }
}
.btn-circle {
  border-radius: 50%;
}

.toolbar {
  cursor: pointer;
}
</style>